import { type DonationDetail, type DonationDetailFromAPI } from './donationTypes';

const optionalString = <T extends string>(value?: T) => (value === '' ? undefined : value);

export const toDonationDetail = ({
  itemId,
  storeLogoUrl,
  storeAddress,
  storePhoneNumber,
  orderId,
  collectionInfo,
  orderState,
  allergensUrl,
  allergensTitle,
  allergensDescription,
  collectionCode,
  ...rest
}: DonationDetailFromAPI): DonationDetail => ({
  ...rest,
  donationId: itemId,
  storeLogoUrl: optionalString(storeLogoUrl),
  storeAddress: optionalString(storeAddress),
  storePhoneNumber: optionalString(storePhoneNumber),
  orderId: optionalString(orderId),
  collectionInfo: optionalString(collectionInfo),
  orderState: optionalString(orderState),
  allergensUrl: optionalString(allergensUrl),
  allergensTitle: optionalString(allergensTitle),
  allergensDescription: optionalString(allergensDescription),
  collectionCode: optionalString(collectionCode),
});
